export * from './caption-input-modal.component';


// WEBPACK FOOTER //
// ./src/app/content/shared/components/inputs/caption/caption-input-modal/index.ts